export default function column(columns, name, columnProperty) {
	if(!columns.entities[name]) {
		columns.entities[name] = {
			name: name,
			value: name,
			property: columnProperty,
			subColumns: {items: [], entities: {}},
			index: columns.items.length
		};
		columns.items.push(columns.entities[name]);
	}

	return columns.entities[name];
};


/** WEBPACK FOOTER **
 ** ./src/js/lib/schedule_table/column.js
 **/